module.exports = __webpack_public_path__ + "img/title-bg.fc4b07ea.png";